"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGHorizontalBounceMoveAnimator = exports.CTGBounceMoveAnimator = exports.CTGMoveAnimator = exports.CTGFadeAnimator = exports.CTGAnimator = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
class CTGAnimator {
    /**
     * Called at start of scene, before any cards have been generated.
     */
    initial_settings(rand, scene, difficulty) { }
    /**
     * Called whenever cards are added.
     */
    on_add_cards(rand, scene, cards, difficulty) { }
    /**
     * Called when game loop runs.
     */
    update_game(rand, scene, cards, now, delta, difficulty) { }
}
exports.CTGAnimator = CTGAnimator;
class CTGFadeAnimator extends CTGAnimator {
    initial_settings(rand, scene, difficulty) { }
    on_add_cards(rand, scene, cards, difficulty) {
        this.update_cards(cards);
    }
    update_game(rand, scene, cards, now, delta, difficulty) {
        this.update_cards(cards);
    }
    update_cards(cards) {
        for (const card of cards) {
            let alpha = 0;
            let fade_start = 16;
            let fade_end = 48;
            if (card.y < fade_start)
                alpha = 0;
            else if (card.y < fade_end)
                alpha = (card.y - fade_start) / (fade_end - fade_start);
            else
                alpha = 1;
            card.set_alpha(Math.min(1, alpha));
        }
    }
}
exports.CTGFadeAnimator = CTGFadeAnimator;
class CTGMoveAnimator extends CTGAnimator {
    constructor(base_pixels_per_second) {
        super();
        this.base_pixels_per_second = base_pixels_per_second;
    }
    initial_settings(rand, scene, difficulty) { }
    on_add_cards(rand, scene, cards, difficulty) {
        this._active_tweens = [];
        this.update_cards(rand, scene, cards, (1 + difficulty) * this.base_pixels_per_second);
    }
    update_game(rand, scene, cards, now, delta, difficulty) { }
    update_cards(rand, scene, cards, pixels_per_second) {
        for (const card of cards) {
            this.animate_card(rand, scene, card, pixels_per_second);
        }
    }
    animate_card(rand, scene, card, pixels_per_second) {
        let new_x = rand.nextInt(8, 64 - 12);
        let new_y = rand.nextInt(8, 64 - 7);
        let old_x = card.x;
        let old_y = card.y;
        let dist = Math.sqrt((card.x - new_x) * (card.x - new_x) + (card.y - new_y) * (card.y - new_y));
        let time = dist / pixels_per_second * 1000;
        const tween = scene.tweens.addCounter({
            from: 0,
            to: 1,
            duration: time,
            ease: 'Quad.easeInOut',
            onUpdate: () => {
                card.move((new_x - old_x) * tween.getValue() + old_x, (new_y - old_y) * tween.getValue() + old_y);
            },
            onComplete: () => {
                this.remove_from_tweens(tween);
                if (!card.destroyed) {
                    this.animate_card(rand, scene, card, pixels_per_second);
                }
            }
        });
        this.add_to_tweens(tween);
    }
    add_to_tweens(tween) {
        this._active_tweens.push(tween);
    }
    remove_from_tweens(tween) {
        this._active_tweens = this._active_tweens.filter(function (el) { return el != tween; });
    }
}
exports.CTGMoveAnimator = CTGMoveAnimator;
const bounds = [[7, 10], [52, 55]];
class CTGBounceMoveAnimator extends CTGAnimator {
    constructor(base_pixels_per_second) {
        super();
        this.base_pixels_per_second = base_pixels_per_second;
    }
    initial_settings(rand, scene, difficulty) {
        this._card_map = new Map();
    }
    on_add_cards(rand, scene, cards, difficulty) {
        const base_speed = (1 + difficulty) * this.base_pixels_per_second;
        cards.forEach((card) => {
            if (card.color() == CTGCard_1.CTGColor.Black) {
                let angle = rand.nextFloat(0, Math.PI * 2);
                this._card_map.set(card, [Math.sin(angle) * base_speed, Math.cos(angle) * base_speed]);
            }
        });
    }
    update_game(rand, scene, cards, now, delta, difficulty) {
        this._card_map.forEach((value, key) => {
            if (key.destroyed) {
                this._card_map.delete(key);
            }
            else {
                key.x += value[0] * delta / 1000;
                key.y += value[1] * delta / 1000;
                if (key.x > bounds[1][0]) {
                    value[0] *= -1;
                    key.x = bounds[1][0] - (key.x - bounds[1][0]);
                }
                else if (key.x < bounds[0][0]) {
                    value[0] *= -1;
                    key.x = bounds[0][0] - (key.x - bounds[0][0]);
                }
                if (key.y > bounds[1][1]) {
                    value[1] *= -1;
                    key.y = bounds[1][1] - (key.y - bounds[1][1]);
                }
                else if (key.y < bounds[0][1]) {
                    value[1] *= -1;
                    key.y = bounds[0][1] - (key.y - bounds[0][1]);
                }
                key.move(key.x, key.y);
            }
        });
    }
}
exports.CTGBounceMoveAnimator = CTGBounceMoveAnimator;
class CTGHorizontalBounceMoveAnimator extends CTGBounceMoveAnimator {
    constructor() {
        super(...arguments);
        this._last_dir_right = false;
    }
    on_add_cards(rand, scene, cards, difficulty) {
        const base_speed = (1 + difficulty) * this.base_pixels_per_second;
        cards.forEach((card) => {
            if (card.color() == CTGCard_1.CTGColor.Black) {
                this._card_map.set(card, [base_speed * (this._last_dir_right ? -1 : 1), 0]);
                this._last_dir_right = !this._last_dir_right;
            }
        });
    }
}
exports.CTGHorizontalBounceMoveAnimator = CTGHorizontalBounceMoveAnimator;
